import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { DexFormsResource } from '@mark43/cad-api';

export function useDexFormsQuery() {
    const apiClient = useApiClient();
    return useQuery(
        ['dex-forms'],
        () => {
            return apiClient
                .request<DexFormsResource.GetDexDispatcherForms>({
                    url: 'dex_forms',
                    method: 'GET',
                })
                .then((resp) => resp.data.data);
        },
        { cacheTime: Infinity, staleTime: Infinity, refetchOnMount: false }
    );
}
